export const getTranslations = () => {
    const lang = window.broadcastPlayerData?.language || 'en-US';
    const isSpanish = lang.toLowerCase().startsWith('es');

    const translations = {
        en: {
            bibleStudy: "Bible Study",
            message: "Message",
            video: "Video",
            series: "Series",
            upNext: "Up Next",
            nowPlaying: "Now Playing",
            loadingPlayer: "Loading player...",
            episode: "Episode",
            song: "Song",
            unmute: "Unmute",
            mute: "Mute",
            advertisement: "ADVERTISEMENT",
            skipAd: "Skip Ad",
            skipAdIn: "Skip ad in ",
            ad: "Ad: ",
            becomeMonthlyCompanionTooltip: "Click to become a Monthly Companion",
            donateTooltip: "Click to Donate and receive a special gift",
            episodeInsight: "Episode Insight",
            readMore: "Read More",
            showLess: "Show Less",
            fullSeries: "Series",
            fullSeason: "Full Season",
            moreFrom: "More from ",
            downloadBibleStudy: "Download Bible Study",
            buyVideo: "Buy Video",
            buyMessage: "Buy Message",
            buySeries: "Buy Series",
            buySeason: "Buy Season",
            visitEpisodePage: "Visit Episode Page",
            viewFullVideo: "View Full Video",
            viewFullMessage: "View Full Message",
            clickToCopy: "Click to copy to clipboard",
            howToShare: "How to Share",
            copied: "Copied to clipboard!",
            copyFailed: "Failed to copy URL.",
            shareStep1: "Click \"Share this {type}\" to copy the URL",
            shareStep2: "Paste the link in social media, email, or text",
            shareStep3: "Others can click the link to {action} to this {type}",
            shareTip: "💡 Tip: The shared link will start playing from the current {itemType} in the {containerType}",
            toolsForParents: "Tools For Parents and More!",
            parentTools: "Parent Tools",
            more: "More",
            inThisEpisode: "In This Episode",
            parentGuidePdf: "Parent Guide (PDF)",
            activitySheetPdf: "Activity Sheet (PDF)",
            joinClub: "Join The Club",
            joinClubCopy: "Join The Club to unlock this episode's Parent Guide and Activity Sheet — plus the Wildwood map, coloring pages, and more!",
            close: "Close",
            watch: "watch",
            listen: "listen",
            buyVideoSeries: "Buy the Video Series",
            viewFullSeries: "View Series",
            viewFullSeason: "View Full Season",
            share: "Share",
            shareThisSermon: "Share this sermon",
            part: "Part",
            scriptureReference: "Scripture Reference"
        },
        es: {
            bibleStudy: "Bosquejo",
            message: "Mensaje",
            video: "Video",
            series: "Serie",
            upNext: "A continuación",
            nowPlaying: "Reproduciendo ahora",
            loadingPlayer: "Cargando reproductor...",
            episode: "Episodio",
            song: "Canción",
            unmute: "Activar sonido",
            mute: "Silenciar",
            advertisement: "PUBLICIDAD",
            skipAd: "Omitir anuncio",
            skipAdIn: "Omitir anuncio en ",
            ad: "Anuncio: ",
            becomeMonthlyCompanionTooltip: "Haga clic para hacerse Compañero Mensual",
            donateTooltip: "Haga clic para donar y recibir un regalo especial",
            episodeInsight: "Información del episodio",
            readMore: "Leer más",
            showLess: "Mostrar menos",
            fullSeries: "Serie",
            fullSeason: "Temporada completa",
            moreFrom: "Más de ",
            downloadBibleStudy: "Descargar bosquejo",
            buyVideo: "Comprar video",
            buyMessage: "Comprar mensaje",
            buySeries: "Comprar serie",
            buySeason: "Comprar temporada",
            visitEpisodePage: "Visitar página del episodio",
            viewFullVideo: "Ver video completo",
            viewFullMessage: "Ver mensaje completo",
            clickToCopy: "Haga clic para copiar al portapapeles",
            howToShare: "Cómo compartir",
            copied: "¡Copiado al portapapeles!",
            copyFailed: "Error al copiar la URL.",
            shareStep1: "Haga clic en \"Compartir este {type}\" para copiar la URL",
            shareStep2: "Pegue el enlace en redes sociales, correo electrónico o mensaje de texto",
            shareStep3: "Otros pueden hacer clic en el enlace para {action} este {type}",
            shareTip: "💡 Sugerencia: El enlace compartido comenzará a reproducirse desde el {itemType} actual en la {containerType}",
            toolsForParents: "¡Herramientas para padres y más!",
            parentTools: "Herramientas para padres",
            more: "Más",
            inThisEpisode: "En este episodio",
            parentGuidePdf: "Guía para padres (PDF)",
            activitySheetPdf: "Hoja de actividades (PDF)",
            joinClub: "Únete al Club",
            joinClubCopy: "¡Únete al Club para desbloquear la Guía para padres y la Hoja de actividades de este episodio, además del mapa de Wildwood, páginas para colorear y más!",
            close: "Cerrar",
            watch: "ver",
            listen: "escuchar",
            buyVideoSeries: "Comprar la serie de videos",
            viewFullSeries: "Ver la serie",
            viewFullSeason: "Ver la temporada completa",
            share: "Compartir",
            shareThisSermon: "Compartir este sermón",
            part: "Parte",
            scriptureReference: "Referencia bíblica"
        }
    };

    return isSpanish ? translations.es : translations.en;
};
